export type Assignee = {
    entityId: string;
    entityType: 'Employee' | 'Team';
};

export type DetailedAssignee = {
    _id: string;
    type: Assignee['entityType'];
    name: string;
};

export type AssigneeItem = { title: string; value: 'Employee' | 'Team' };

/**
 * Converts the value from DetailedAssignee to Assignee
 */
export function detailedAssigneeToAssignee(assignee: DetailedAssignee | Assignee | undefined | null): Assignee | undefined {
    if (!assignee) return undefined;

    if ('entityId' in assignee) {
        return {
            entityId: assignee.entityId,
            entityType: assignee.entityType
        };
    }

    if ('_id' in assignee) {
        return {
            entityId: (assignee as DetailedAssignee)._id,
            entityType: (assignee as DetailedAssignee).type
        };
    }

    return undefined;
}
